export default __webpack_public_path__ + "static/media/hht1_ep14_timeline_12.370a02a0.png";